import * as d3 from 'd3';

export function drawQueenAnneGrills(
  svg,
  x,
  y,
  width,
  height,
  frameWidth = 10,
  verLines = 2,            // Number of vertical grill bars
  horLines = 2,            // Number of horizontal grill bars
  lineColor = 'white',
  borderColor = 'black',
  borderWidth = 0.2,
  grillThickness = 2,
  topGridFraction = 0.33   // Portion of height for the top grid (e.g., 1/3)
) {
  const glassX = x;
  const glassY = y;
  const glassWidth = width;
  const glassHeight = height;

  // Calculate the height of the top grid (default to top 1/3)
  const topGridHeight = glassHeight * topGridFraction;

  // --- Full height vertical bars ---
  for (let i = 1; i <= verLines; i++) {
    const gx = glassX + (glassWidth * i) / (verLines + 1);
    svg.append('rect')
      .attr('x', gx - grillThickness / 2)
      .attr('y', glassY)
      .attr('width', grillThickness)
      .attr('height', glassHeight)
      .attr('fill', lineColor)
      .attr('stroke', borderColor)
      .attr('stroke-width', borderWidth);
  }

  // --- Full height horizontal bars ---
  for (let i = 1; i <= horLines; i++) {
    const gy = glassY + (glassHeight * i) / (horLines + 1);
    svg.append('rect')
      .attr('x', glassX)
      .attr('y', gy - grillThickness / 2)
      .attr('width', glassWidth)
      .attr('height', grillThickness)
      .attr('fill', lineColor)
      .attr('stroke', borderColor)
      .attr('stroke-width', borderWidth);
  }

  // --- Vertical bars in top grid only ---
  for (let i = 1; i <= verLines; i++) {
    const gx = glassX + (glassWidth * i) / (verLines + 1);
    svg.append('rect')
      .attr('x', gx - grillThickness / 2)
      .attr('y', glassY)
      .attr('width', grillThickness)
      .attr('height', topGridHeight)
      .attr('fill', lineColor)
      .attr('stroke', borderColor)
      .attr('stroke-width', borderWidth);
  }

  // --- Horizontal line separating top grid from lower part ---
  const topGridBottomY = glassY + topGridHeight;
  svg.append('rect')
    .attr('x', glassX)
    .attr('y', topGridBottomY - grillThickness / 2)
    .attr('width', glassWidth)
    .attr('height', grillThickness)
    .attr('fill', lineColor)
    .attr('stroke', borderColor)
    .attr('stroke-width', borderWidth);
}
